import React from 'react';
import styled from 'styled-components';
import Checkbox from '@mui/material/Checkbox';

const ComfirmMessageStyle = styled.div<ComfirmMessageProps>`
  font-size: 16px;
  text-align: center;
  color: red;
`;

const CheckBoxContainer = styled.div`
  margin: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface ComfirmMessageProps {
  name?: string;
  message?: string;
  className?: string;
  isDeleteComfirmMessage?: boolean;
  isCopyComfirmMessage?: boolean;
  checkboxMessage?: string;
  checkboxValue?: boolean;
  checkboxOnChange?: (v: boolean) => void;
}

export const ComfirmMessage: React.FC<ComfirmMessageProps> = (props) => {
  const actionMessage = props.isCopyComfirmMessage ? 'コピー' : props.isDeleteComfirmMessage ? '削除' : ''
  const m = actionMessage ? `を${actionMessage}します。よろしいですか？` : props.message
  return <>
    <ComfirmMessageStyle {...props}>{props.name || ''}{m}</ComfirmMessageStyle>
    {
      props.checkboxMessage && (
      <CheckBoxContainer>
        <Checkbox
          color="primary"
          checked={props.checkboxValue}
          id="comfirmCheckbox"
          onChange={() => props.checkboxOnChange!(!props.checkboxValue)}
        /> <label htmlFor="comfirmCheckbox">{props.checkboxMessage}</label>
      </CheckBoxContainer>
    )}
  </>
};

export default ComfirmMessage